import styled from "styled-components"

export const Wrapper = styled.div`
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 2.5rem;
  color: var(--illiniDarkBlue);
  padding-top: 2rem;
  width: 100%;

  a {
    margin-right: 0.5rem;
    -webkit-text-decoration: none;
    text-decoration: none !important;
    font-style: normal !important;
    color: var(--illiniDarkBlue);
  }
  .page {
    color: var(--darkestGrey);
  }
  img {
    margin: 0;
    padding: 0;
    margin-right: 0.5rem;
  }
`
